<template>
  <div class="d-flex flex-column fv-row mb-2 flex-wrap">
    <label v-if="label" class="align-items-center dm-fs-0-9-rem fw-bolder form-label" :class="{required_star: required}"
           :for="name"
    >
      <slot name="labelText">{{ label }}</slot>
    </label>
    <!--    {{classes}}-->
    <slot>
      <select2
          @open="mouseEnter"
          :value="value"
          @change="emitValue"
          v-bind="{...$attrs, disabled}"
          v-on="$listeners"
          :invalid="isInvalid"
          :classes="classes"
      />
    </slot>
    <has-error v-if="form" :form="form" :field="name"></has-error>
    <div ref="tooltipx" v-show="debounce && duplicates.length && mouseOn" class="tooltipx" tabindex="-1"
         @focusout="mouseLeave_" style="left:260px">
      <div class="tooltiptext bg-gray-900 text-white p-2">
        <div class="row">
          <div class="col-md-9">
            <div class="p-2">
              <b>Possible Duplicates</b>
            </div>
          </div>
          <div class="col-md-3">
            <div class="btn btn-sm btn-icon btn-active-color-primary justify-content-end" @click="mouseLeave"
                 style="float:right"><span class="svg-icon svg-icon-1"><svg xmlns="http://www.w3.org/2000/svg"
                                                                            width="24" height="24" viewBox="0 0 24 24"
                                                                            fill="none"><rect opacity="0.5" x="6"
                                                                                              y="17.3137" width="16"
                                                                                              height="2" rx="1"
                                                                                              transform="rotate(-45 6 17.3137)"
                                                                                              fill="currentColor"></rect><rect
                x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                fill="currentColor"></rect></svg></span></div>
          </div>
        </div>
        <hr width="100%" style="margin-top:0;">
        <div :key="`dupl--${d.id}`" v-for="d in duplicates" class="duplicates">{{ d[debounceSettings.label] }}
          <router-link :to="{name: debounceSettings.route_name, params: {id: d.id}}"
                       v-show="debounceSettings.route_name" target="_blank" style="float:right">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                 class="bi bi-arrow-up-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                    d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"/>
            </svg>
          </router-link>
          <hr width="100%">
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.tooltipx .tooltiptext::after {
  left: 4% !important;
}
</style>
<script>
export default {
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    value: null,
    name: {
      type: String | Number,
      required: true,
    },
    disabled: {
      default: false,
    },
    label: {
      type: String | Number,
    },
    required: {
      type: Boolean | Number | Object, // null is an object
      default: true
    },
    form: {
      type: Object,
      default: null,
      required: false,
    },
    classes: {
      default: () => ['form-select-solid form-select-sm']
    },
    debounce: {
      default: false,
    },
    debounceSettings: {
      default: () => ({
        url: null,
        param: 'id',
        label: 'title',
        extra_params: {},
        route_name: null,
      }),
    },
  },
  data() {
    return {
      mouseOn: false,
      searching: false,
      duplicates: [],
    }
  },
  computed: {
    isInvalid(){
      return this.form.errors.has(this.name)
    }
  },
  methods: {
    emitValue(value) {
      this.$emit('input', value)
      this.search(value)
    },
    search(value) {
      if (!this.debounce) return;

      if (!value) {
        this.duplicates = []
        return
      }

      let dbParams = {
        ..._.get(this.debounceSettings, 'extra_params', {}),
      }
      dbParams[this.debounceSettings.param] = value
      this.searching = true
      this.$axios.get(this.debounceSettings.url, {
        params: {
          ...dbParams,
        }
      })
          .then(({data}) => {
            this.duplicates = data.data
            this.$nextTick(() => {
              $(".duplicates").unmark()
              $(".duplicates").mark(this.value);

              this.$refs.tooltipx.focus()
            })
          })
          .catch(err => this.toastLaraValidation(err))
          .finally(() => this.searching = false)
    },
    mouseEnter() {
      console.log('mouseEnter')
      this.mouseOn = true
    },
    mouseLeave() {
      console.log('mouseLeave')
      this.mouseOn = false
    },
    mouseLeave_() {
    },
  }
}
</script>